import compact from "lodash/compact";
import take from "lodash/take";

export default function initials(name) {
  if (!name) {
    return;
  }

  const words = compact(take(name.split(/[\s@\-_]/), 2));
  const letters = words.map(word => word.charAt(0));

  return letters.join("");
}
